module.exports = __webpack_public_path__ + "static/media/dashboard-24px.40734c5e.svg";